// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
// import VueResource from 'vue-resource';
import axios from 'axios';
import VueAxios from 'vue-axios';
import LinkPrevue from 'link-prevue';
import { ClientTable } from 'vue-tables-2';
// import DataTable from 'v-data-table';
import App from './App';
import router from './router';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../static/lib/dropzone/dropzone.css';
import '../static/lib/confirm/jquery-confirm.min.css';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

Vue.use(ClientTable);
Vue.use(VueAxios, axios);
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App, LinkPrevue },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js